import { render, staticRenderFns } from "./Iovation.vue?vue&type=template&id=5b3565e0&"
import script from "./Iovation.vue?vue&type=script&lang=js&"
export * from "./Iovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports